@if (description) {
  <div class="silder">
    <div (click)="closePopup()" class="cross">
      <ion-icon name="close" class="close"></ion-icon>
    </div>
    <!-- progress -->
    <div class="progress">
      <div class="bar1" (click)="nextSlider($event,1)">.</div>
      <div class="bar2" (click)="nextSlider($event,2)">.</div>
      <div class="bar3" (click)="nextSlider($event,3)">.</div>
    </div>
    <div class="pick">
      <h3>{{title}}</h3>
    </div>
    <div class="gif-outs">
      <div class="gif-out">
        <h4>GIF</h4>
      </div>
    </div>
    <div class="select-lucky-nos">
      <h4>{{description}}</h4>
    </div>
  </div>
}